// eslint-disable-next-line no-restricted-imports
import { withRouter as legacyWithRouter } from "react-router";

// eslint-disable-next-line import/prefer-default-export
export function withRouter(children) {
  return legacyWithRouter(children);
}
